import { createAction } from '@reduxjs/toolkit'

export const restoreRetailer = createAction('deleted/restoreRetailer')
